import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux';
import * as actionCreators from 'store/actions'
import { Redirect } from 'react-router-dom';

import { Button, TextField, Animation, Particles, Paper } from 'components'
import NameTab from './NameTab'
import ThemeTab from './ThemeTab'

const Background = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
`

const Container = styled.div`
    border-radius: 5px;
    width: 25rem;
    background-color: var(--primary-color);
    display: flex;
    flex-direction: column;
    padding: 3rem;
    overflow: hidden;
    position: relative;
`

const Footer = styled.div`
    display: grid;
    grid-template-columns: 5rem auto 5rem;
`

const IndicatorContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const Indicator = styled.div`
    background-color: ${props => props.active ? 'var(--text-color)' : 'var(--secondary-color)'};
    border-radius: 100%;
    width: 0.5rem;
    height: 0.5rem;
    font-size: 0.5rem;
    margin: 0 0.2rem 0 0.2rem;
    cursor: pointer;
`

class GettingStartedScreen extends Component {
    constructor(props){
        super(props);
        this.state = {
            tab: 'NAME', // NAME or THEME,
            first_name: null,
            theme: 'Dark'
        }
    }
    componentDidMount() {
        window.addEventListener('keydown', this.keyHandler, true)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.keyHandler, true)
    }

    keyHandler = (event) => {
        if(this.state.tab === 'THEME'){
            switch(event.keyCode){
                case 13:
                    this.submitHandler()
                    break
                case 39:
                    this.setState({theme: 'Light'})
                    break
                case 37:
                    this.setState({theme: 'Dark'})
                    break
            }
        } else if (this.state.tab === 'NAME'){
            event.keyCode === 13 && this.submitHandler()
        }
    }
    
    submitHandler = () => {
        if(this.state.tab === 'NAME'){
            this.setState({
                tab: 'THEME'
            })
        } else if (this.state.tab === 'THEME') {
            let updatedUser = this.props.user
            updatedUser['first_name'] = this.state.first_name
            updatedUser['theme'] = this.state.theme
            updatedUser['setup_completed'] = true
            updatedUser['show_loginModal'] = true
            console.log('update user', updatedUser, this.props.data)
            this.props.updateUser(updatedUser)
        }
    }

    render() {
        return (
            <Particles>
                <Background>
                    <Paper>
                        <Container>
                            {this.props.user && this.props.user.setup_completed && <Redirect to='/loading'/>}
                            {this.state.tab === 'NAME' ? <NameTab value={this.state.first_name} onChange={(value) => this.setState({first_name: value})} onSubmit={this.submitHandler}/>
                            : this.state.tab === 'THEME' ? <ThemeTab value={this.state.theme} onChange={(theme) => this.setState({theme: theme})} onSubmit={this.submitHandler}/>
                            : <div>Something went wrong</div>}

                            <Footer>
                                {this.state.tab === 'THEME' ? <Button text='Back' styles={{width: 'fit-content', backgroundColor: 'var(--primary-color)', boxShadowColor: 'transparent', margin: '0.5rem 0'}} onSelect={() => this.setState({tab: 'NAME'})}/> : <div/>}
                                <IndicatorContainer>
                                    <Indicator active={this.state.tab === 'NAME'} onClick={() => this.setState({tab: 'NAME'})}/>
                                    <Indicator active={this.state.tab === 'THEME'} onClick={() => this.state.first_name && this.setState({tab: 'THEME'})}/>
                                </IndicatorContainer>
                                <Button 
                                    text={this.state.tab === 'THEME' ? 'Submit' : 'Next'} 
                                    styles={{backgroundColor: 'var(--focus-color)', margin: '0.5rem 0'}}
                                    onSelect={this.submitHandler}
                                    />
                            </Footer>
                        </Container>
                    </Paper>
                </Background>
            </Particles>
        )
    }
}

const mapStateToProps = state => {
    return {
            user: state.auth.user,
            data: state.db.present.data && state.db.present.data.toJS(),
        };
    };
    
const mapDispatchToProps = dispatch => {
    return {
        updateUser: (user) => dispatch(actionCreators.updateUser(user)),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( GettingStartedScreen ); 